import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaArrowLeft, FaRobot, FaHeadset } from "react-icons/fa";
import useSEO from "./useSEO";

const ThankYou = () => {
  useSEO({
    title: "Thank You | Core Spectators",
    description: "Thank you for submitting your project specifications to Core Spectators. Our technical team is reviewing your requirements.",
    canonical: "https://corespectators.com/thank-you",
    noIndex: true
  });

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-gray-50 py-16 px-4">
      <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 p-8 sm:p-12 max-w-xl w-full text-center">
        <div className="w-20 h-20 bg-green-50 text-green-600 rounded-full flex items-center justify-center text-4xl mx-auto mb-6 shadow-inner">
          <FaCheckCircle />
        </div>
        
        <span className="text-xs uppercase font-bold tracking-widest text-green-600 bg-green-100 px-3 py-1 rounded-full">
          Submission Received
        </span>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mt-4 mb-3">
          Thank You for Reaching Out!
        </h1>

        <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-6">
          Our engineering team has received your project details. We are analyzing your specifications and will respond within 24 hours with an actionable roadmap.
        </p>

        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-4 mb-8 text-left space-y-2 text-xs sm:text-sm text-gray-700">
          <div className="flex items-center gap-2">
            <FaRobot className="text-red-600 shrink-0" />
            <span>AI Automated Confirmation has been logged</span>
          </div>
          <div className="flex items-center gap-2">
            <FaHeadset className="text-red-600 shrink-0" />
            <span>Direct Support: <a href="mailto:contact@corespectators.com" className="text-red-600 font-semibold underline">contact@corespectators.com</a></span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-xl shadow-md transition flex items-center justify-center gap-2 text-sm sm:text-base"
          >
            <FaArrowLeft className="text-xs" /> Back to Homepage
          </Link>
          <Link
            to="/Services"
            className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3 px-6 rounded-xl transition text-sm sm:text-base"
          >
            Explore AI Solutions
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;